export const getAvatarUrl = (userData, user) => {
  if (userData?.custom_avatar && userData?.thumbnail_url) {
    return userData.thumbnail_url;
  }
  return userData?.picture || user?.picture;
};